<script>

export default {
  props: ['item'],
  data() {
    return {
      timezones: [
        'America/New_York',
        'America/Chicago',
        'America/Denver',
        'America/Phoenix',
        'America/Los_Angeles',
        'America/Anchorage',
        'America/Adak',
        'Pacific/Honolulu',
      ],

      loading_roles: true,
      roles: [],

      loading_leadrecipients: true,
      leadrecipients: [],

      loading_leadtypes: true,
      leadtypes: [],
    }
  },
  created() {
    this.fetch_roles();
    this.fetch_leadrecipients();
    this.fetch_leadtypes();
  },
  methods: {
    fetch_roles() {
      this.loading_roles = true;
      this.$http.get('/api/roles/fetch').then(res => {
        // console.log(res);
        this.roles = res.data.data;
        this.loading_roles = false;
      }).catch(res => { this.loading_roles = false; this.popupErrors(res); });
    },
    fetch_leadrecipients() {
      this.loading_leadrecipients = true;
      this.$http.get('/api/leadrecipients/fetch', {params: {paginate: 100, page: 1, total: 0, wheres: {status: 1}}}).then(res => {
        // console.log(res);
        this.leadrecipients = res.data.data;
        this.loading_leadrecipients = false;
      }).catch(res => { this.loading_leadrecipients = false; this.popupErrors(res); });
    },
    fetch_leadtypes() {
      this.loading_leadtypes = true;
      this.$http.get('/api/leadtypes/fetch', {params: {paginate: 100, page: 1, total: 0, wheres: {status: 1}}}).then(res => {
        // console.log(res);
        this.leadtypes = res.data.data;
        this.loading_leadtypes = false;
      }).catch(res => { this.loading_leadtypes = false; this.popupErrors(res); });
    },
  }
}
</script>

<template>
  <div>
    <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Personal details :</h5>
    <div class="row">
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Full name :" v-model="item.name" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Email address :" v-model="item.email" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="Phone" Title="Phone number :" v-model="item.phone"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.website" :Options="app_website_ids" Title="Website :" required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" Title="Timezone :" :Options="timezones" v-model="item.timezone"></w-field>
      </div>
      <div v-if="item.id" class="col-sm-4">
        <w-field SimpleDataType="String List, Single" Title="Email verified? :" :Options="[{name: 'Yes', value: 'Yes'},{name: 'No', value: 'No'}]" v-model="item.email_verified_at_placeholder"></w-field>
      </div>

      <div v-if="!item.id" class="col-sm-12 mb-2">
        <div class="custom-control custom-switch custom-success my-2">
          <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="item.verified">
          <label class="custom-control-label" for="customSwitch1">Set up login credentials for this Person?</label>
        </div>
      </div>
    </div>
    <div v-if="item.verified">
      <div class="alert alert-warning">
        <Icon icon="ri:error-warning-line" class="mr-2"></Icon> An email will be sent to this person with instructions on setting up their password.
      </div>
    </div>

    <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Physical address :</h5>
    <div class="row">
      <div class="col-sm-12">
        <w-field SimpleDataType="String" Title="Physical address :" v-model="item.Address"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Physical city :" v-model="item.City"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Physical state :" v-model="item.StateOrProvince"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Physical zip code :" v-model="item.PostalCode"></w-field>
      </div>
    </div>

    <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Mailing address :</h5>
    <div class="row">
      <div class="col-sm-12">
        <w-field SimpleDataType="String" Title="Mailing address :" v-model="item.MailingAddress"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Mailing city :" v-model="item.MailingCity"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Mailing state :" v-model="item.MailingStateOrProvince"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Mailing zip code :" v-model="item.MailingPostalCode"></w-field>
      </div>
    </div>

    <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Billing address :</h5>
    <div class="row">
      <div class="col-sm-12">
        <w-field SimpleDataType="String" Title="Billing address :" v-model="item.BillingAddress"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Billing city :" v-model="item.BillingCity"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Billing state :" v-model="item.BillingStateOrProvince"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Billing zip code :" v-model="item.BillingPostalCode"></w-field>
      </div>
    </div>


    <h5 v-if="hasRole(['Dev','Admin'])" class="section-header mt-5 mb-2"><Icon icon="ri:book-2-line"></Icon> Admin Settings :</h5>
    <p v-if="hasRole(['Dev','Admin'])" class="text-muted small mb-2">These options will grant access to the admin sytem.</p>
    <div class="row">
      <!-- <div v-if="hasRole(['Dev','Admin'])" class="col-sm-6">
        <div role="group" class="form-group">
          <label for="input-lead_recipients" class="d-block">Lead recipients:</label>
          <div class="bv-no-focus-ring">
            <multiselect id="input-lead_recipients" v-model="item.lead_recipients" :options="leadrecipients" :taggable="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select..." label="name" track-by="id">
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <i v-if="loading_leadrecipients" class="spinner-border spinner-border-sm"></i>
                <span v-for="(role, role_i) in values" :key="role_i"><span v-if="role_i > 0">, </span>{{role.name}}</span>
              </template>
            </multiselect>
          </div>
        </div>
      </div> -->
      <!-- <div v-if="hasRole(['Dev','Admin'])" class="col-sm-6">
        <div role="group" class="form-group">
          <label for="input-lead_types" class="d-block">Lead types:</label>
          <div class="bv-no-focus-ring">
            <multiselect id="input-lead_types" v-model="item.lead_types" :options="leadtypes" :taggable="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select..." label="name" track-by="id">
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <i v-if="loading_leadtypes" class="spinner-border spinner-border-sm"></i>
                <span v-for="(role, role_i) in values" :key="role_i"><span v-if="role_i > 0">, </span>{{role.name}}</span>
              </template>
            </multiselect>
          </div>
        </div>
      </div> -->
      <div v-if="hasRole(['Dev','Admin'])" class="col-sm-6">
        <div role="group" class="form-group">
          <label for="input-roles" class="d-block">Roles:</label>
          <div class="bv-no-focus-ring">
            <multiselect id="input-roles" v-model="item.roles" :options="roles" :taggable="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select..." label="title" track-by="id">
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <i v-if="loading_roles" class="spinner-border spinner-border-sm"></i>
                <span v-for="(role, role_i) in values" :key="role_i"><span v-if="role_i > 0">, </span>{{role.title}}</span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
    </div>

    <div class="clearfix mt-3"></div>

  </div>
</template>
